import { useState } from 'react';

import {
  ShopInsuranceFilters,
  type ShopInsuranceFiltersComponentProps,
} from '@/features/shop-insurance/components/shop-insurance-filters';
import { Button, Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@design-system';

import { SlidersHorizontal } from 'lucide-react';

type ShopInsuranceFiltersSidebarProps = Pick<
  ShopInsuranceFiltersComponentProps,
  | 'showEligibilityFilter'
  | 'eligibilityCounts'
  | 'mode'
  | 'handleModeChange'
  | 'benefitDesignAvailableOptions'
  | 'benefitDesignDraftFilters'
  | 'availableCarriers'
  | 'visibleQuoteCount'
>;

export function ShopInsuranceFiltersSidebar(props: ShopInsuranceFiltersSidebarProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile Sheet */}
      <Sheet
        open={open}
        onOpenChange={setOpen}
      >
        <SheetTrigger asChild>
          <Button
            className="flex w-full lg:hidden"
            variant="outline"
          >
            <SlidersHorizontal className="size-4" />
            Filters
          </Button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="overflow-y-auto"
        >
          <SheetHeader>
            <SheetTitle className="text-gray-950">Filters</SheetTitle>
          </SheetHeader>
          <div className="pb-6">
            <ShopInsuranceFilters
              {...props}
              onMobileClose={() => setOpen(false)}
            />
          </div>
        </SheetContent>
      </Sheet>

      {/* Desktop Sidebar */}
      <div className="sticky top-0 hidden h-screen shrink-0 basis-80 overflow-y-auto px-1 pb-64 pt-6 lg:block">
        <ShopInsuranceFilters {...props} />
      </div>
    </>
  );
}
